"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterDependencies = void 0;
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var filterDependencies = exports.filterDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createFilter: _factoriesAny.createFilter
};